export default {
  tenants: [],
};
